import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Select } from "antd"
import { listLocal } from "../../../helpers/filtersTable"
import { getListShippingCarrier } from '../../../../services/api/apiShippingCarrier'

SelectInput.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string.isRequired,
    validate: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

function SelectInput(props) {
    const [listShippingCarrier, setListShippingCarrier] = useState([])
    const [allShippingCarrier, setAllShippingCarrier] = useState([])
    function _onChange(value) {
        const { onChange } = props

        if (typeof onChange === 'function') {
            onChange(value)
            setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active || i.slug === value) || [])
        }
    }

    const fetchFiltersShippingCarrier = async (payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrier(newPayload)
            const { data, success, message } = { ...res }
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            setListShippingCarrier(shippingCarriers.filter(i => !!i.is_active) || [])
            setAllShippingCarrier(shippingCarriers || [])

        } catch (error) {
            alert(error.message)
        }
    }

    useEffect(() => {
        fetchFiltersShippingCarrier()
    }, [])

    const { label, value, validate } = props
    const shippingCarrierOption = !!listShippingCarrier && listShippingCarrier.length > 0 ? listShippingCarrier.map(i => ({
        value: i.slug,
        name: i.name,
        is_active: i.is_active,
    })) : []
    const { Option } = Select

    return (
        <div className="SelectInput">
            <label htmlFor="">{label} <span className='Required'>*</span></label>
            <Select
                value={value || []}
                onChange={_onChange}
                className={(!!validate && validate.length > 0) ? 'Error' : ''}
                showSearch
                allowClear={true}
                onSearch={(value) => {
                    if (value) {
                        const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                        setListShippingCarrier(newList)
                    } else { setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active)) }
                }}
                onBlur={() => setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active))}
                filterOption={(input, option) => {
                    return option.children.toLowerCase().includes(input.toLowerCase())
                }}
            >
                {shippingCarrierOption.map((option, index) => (
                    <Option key={`${'shipping_carrier'}_${option.value}_${index + 1}`} value={option.value} style={!option.is_active ? {} : { color: '#333' }}>{option.name}</Option>
                ))}
            </Select>

            {
                !!validate && validate.length > 0 && <small className="Validate">{validate}</small>
            }
        </div>
    )
}

export default SelectInput
